import {
    ApiResponse,
    getAxiosClient,
    makeApiRequest,
    toISODate,
} from '@givelify/utils';
import { IReportsService } from './IReportsService';
import { ReportsEndpoints } from './reportsEndpoints';
import { GenerateCustomReportRequest } from './requests';
import { GenerateReportResponse } from './responses';

export class ReportsService implements IReportsService {
    public async generateCustomReport(
        payload: GenerateCustomReportRequest,
    ): Promise<ApiResponse<GenerateReportResponse>> {
        const url = ReportsEndpoints.generate();
        const httpRequest = getAxiosClient(undefined, {
            caseFunctions: {
                snake: (input) => input,
            },
        }).post(url, {
            ...payload,
            startDate: toISODate(payload.startDate),
            endDate: toISODate(payload.endDate),
        });
        const result = await makeApiRequest<GenerateReportResponse>(
            httpRequest,
        );
        return result;
    }
}
